import { Components, Theme } from '@mui/material';

export const modalOverrides: Components<Theme>['MuiModal'] = {
  styleOverrides: {
    backdrop: {
      background: '#050F194D',
    },
  },
};
